export default __webpack_public_path__ + "static/media/lumpsum-notification.c4fbf1c0.svg";